// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowUp10 as RawArrowUp10 } from "lucide-react";
export const ArrowUp10 = /* @__PURE__ */ createIcon(RawArrowUp10, "ArrowUp10", 2);
